(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[40],{

/***/ "LP0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("1JJ2");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("829J");
/* harmony import */ var _tracking_track_page_TrackPage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tZiC");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("DqI1");
/* harmony import */ var _components_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("e0Ti");
/* harmony import */ var _components_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("i5Mr");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qBqs");
/* harmony import */ var _components_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("0IQ5");
/* harmony import */ var _components_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ZNfd");
/* harmony import */ var _components_widgets_hero_Hero__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2B1m");




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;












var ratioDisplays = [{
  value: 0.3,
  unit: 'rem'
}, {
  value: 0.3,
  unit: 'vw'
}, {
  value: 0.8,
  unit: 'vw'
}, {
  value: 0.8,
  unit: 'vw'
}];

var NotFoundView = function NotFoundView(_ref) {
  var config = _ref.config;
  var notFound = config.errors.notFound;

  var _useResponsive = Object(_components_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_6__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_9__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], null, __jsx(_tracking_track_page_TrackPage__WEBPACK_IMPORTED_MODULE_8__[/* TrackPage */ "a"], {
    pageName: _tracking_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRACK_PAGE_NAMES */ "H"].ERROR_404
  }), __jsx("main", {
    className: "relative -mb-40 text-white sm:-mb-60",
    role: "main"
  }, __jsx(_components_widgets_hero_Hero__WEBPACK_IMPORTED_MODULE_15__[/* Hero */ "a"], {
    url: notFound.image,
    size: "large"
  }), __jsx("div", {
    className: "absolute inset-0 flex w-full items-center"
  }, __jsx(_components_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_14__[/* SiteContainer */ "a"], {
    className: "mt-navigation pb-20"
  }, __jsx("h1", {
    className: "text-center font-brand text-24 leading-tight text-black sm:text-32"
  }, notFound.title), __jsx("h2", {
    className: "text-center font-sans text-16 text-black"
  }, notFound.description), __jsx("div", {
    className: "flex justify-center"
  }, __jsx(_components_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_10__[/* Button */ "a"], {
    className: "mt-20",
    onClick: function onClick() {
      return trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRACK_EVENT_NAMES */ "F"].CLICK_ERROR, {
        detail_click: 'return_to_homepage'
      });
    },
    url: "/"
  }, config.common.goToHome))))), __jsx(_components_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_14__[/* SiteContainer */ "a"], {
    className: "pb-60"
  }, __jsx("div", {
    className: "mb-20 flex flex-col items-center gap-20 md:flex-row"
  }, notFound.items.map(function (item) {
    return __jsx(_components_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"], {
      className: "relative isolate block w-[345px] overflow-hidden rounded-12 shadow-diffuse md:w-380",
      key: item.backgroundURL,
      url: item.link
    }, __jsx(_components_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_13__[/* Image */ "a"], {
      dimensions: isTablet ? {
        h: 380,
        w: 380
      } : {
        h: 345,
        w: 345
      },
      imageUrl: item.backgroundURL,
      ratioDisplay: ratioDisplays
    }), __jsx("span", {
      className: "absolute inset-0 isolate flex w-full flex-col justify-end bg-[linear-gradient(180deg,rgba(0,0,0,0)_39.4%,#2B2323_114.22%)] p-20"
    }, __jsx("span", {
      className: "inline-flex items-center gap-10 font-sans text-20 font-bold leading-1 text-white"
    }, item.label, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
      hasRtl: true,
      name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ARROW_RIGHT,
      width: "0.75rem"
    }))));
  }))));
};

NotFoundView.pageId = 'NotFound';
/* harmony default export */ __webpack_exports__["a"] = (NotFoundView);

/***/ }),

/***/ "LamU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveAppContext; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var moment_moment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("wd/R");
/* harmony import */ var moment_moment__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(moment_moment__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _initAppContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("yEwm");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("kiXb");
/* harmony import */ var _components_utils_responsive_Responsive_helper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("GRjW");













function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





 // Server-side the context is created everytime
// client-side, it's first saved in the constructor of _app, then retrieved in subsequent
// getInitialProps

var localAppContext; // $FlowFixMe

var getAppContext = function getAppContext() {
  return localAppContext;
};
var saveAppContext = function saveAppContext(appContext) {
  var _appContext$device;

  var userAgent = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(window, 'navigator.userAgent');

  var data = _objectSpread(_objectSpread({}, appContext), {}, {
    cookies: js_cookie__WEBPACK_IMPORTED_MODULE_12___default.a.get(),
    userAgent: userAgent,
    device: (_appContext$device = appContext.device) !== null && _appContext$device !== void 0 ? _appContext$device : Object(_components_utils_responsive_Responsive_helper__WEBPACK_IMPORTED_MODULE_16__[/* getDeviceByUA */ "c"])(userAgent)
  });

  localAppContext = _objectSpread(_objectSpread({}, data), Object(_initAppContext__WEBPACK_IMPORTED_MODULE_14__[/* initAppContext */ "a"])(data.originalUrl, data));

  var momentLocale = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(localAppContext, "availableLocales.".concat(localAppContext.locale, ".moment"), 'fr'); // $FlowFixMe async import for only one specific moment's locale file


  __webpack_require__("dIgr")("./".concat(momentLocale)).then(function () {
    moment_moment__WEBPACK_IMPORTED_MODULE_13___default.a.locale(momentLocale);
  });
  Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* setLocale */ "g"])(localAppContext.locale.slice(0, 2));
  return localAppContext;
};

/***/ }),

/***/ "Y0NT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "notFoundInitialProps", function() { return /* binding */ notFoundInitialProps; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("mlET");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__("Cm4o");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/server/context/createAppContextFromReq.js + 2 modules
var createAppContextFromReq = __webpack_require__("xb8T");

// EXTERNAL MODULE: ./src/client/context/createOrUpdateAppContext.js
var createOrUpdateAppContext = __webpack_require__("LamU");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./tailwind.config.js
var tailwind_config = __webpack_require__("0mz7");

// CONCATENATED MODULE: ./src/client/views/errors/internal-server-error/InternalServerErrorView.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var STYLES = {
  MAIN: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    color: 'white',
    fontFamily: tailwind_config["theme"].fontFamily.sans,
    minHeight: '100vh'
  },
  CONTAINER: {
    margin: 'auto',
    maxWidth: '76.25rem'
  },
  HEADER: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    height: '11rem',
    justifyContent: 'space-between',
    padding: '1rem'
  },
  HEADING: {
    margin: 0,
    maxWidth: 320,
    width: '11rem'
  },
  ASIDE: {
    padding: '0 1rem',
    textAlign: 'right'
  },
  CONTACT: {
    margin: 0,
    padding: 0
  },
  CONTENT: {
    backgroundImage: 'radial-gradient(closest-side,rgba(0,0,0,.2),transparent)',
    maxWidth: '73.75rem',
    textShadow: '0 0 1rem rgba(0,0,0,.4)'
  },
  TITLE: {
    fontFamily: tailwind_config["theme"].fontFamily.brand,
    fontSize: 'calc(2vw + 10px)',
    margin: '0 0 1rem',
    textAlign: 'right'
  },
  MESSAGE: {
    fontSize: 'calc(2vw + 5px)',
    textAlign: 'right'
  },
  LINK: {
    color: 'white',
    fontWeight: 'bold'
  }
};

var InternalServerErrorView_InternalServerErrorView = function InternalServerErrorView(_ref) {
  var error = _ref.error;
  return __jsx("main", {
    style: _objectSpread(_objectSpread({}, STYLES.MAIN), {}, {
      backgroundImage: "url(".concat(error.backgroundImage, ")")
    }),
    role: "main"
  }, __jsx(TrackPage["a" /* TrackPage */], {
    pageName: constants["H" /* TRACK_PAGE_NAMES */].ERROR_500
  }), __jsx(head_default.a, null, __jsx("title", null, error.pageTitle)), __jsx("div", {
    style: STYLES.CONTAINER
  }, __jsx("div", {
    style: STYLES.HEADER
  }, __jsx("h1", {
    style: STYLES.HEADING
  }, __jsx(Icon["a" /* Icon */], {
    alt: "ClubMed",
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED,
    style: {
      color: colors["a" /* COLORS */].WHITE
    },
    width: "11rem"
  })), __jsx("div", {
    style: STYLES.ASIDE
  }, __jsx("p", {
    style: STYLES.CONTACT
  }, error.travelAdvisor), __jsx("p", {
    style: STYLES.CONTACT
  }, error.phone))), __jsx("div", {
    style: STYLES.CONTENT
  }, __jsx("p", {
    style: STYLES.TITLE
  }, error.title), __jsx("div", {
    style: STYLES.MESSAGE
  }, error.callUs, "\xA0", __jsx("a", {
    "data-testid": "InternalServerError-phoneLink",
    href: "tel:".concat(error.phone),
    style: STYLES.LINK
  }, error.phone)))));
};

InternalServerErrorView_InternalServerErrorView.pageId = 'InternalError';
InternalServerErrorView_InternalServerErrorView.disableHeader = true;
InternalServerErrorView_InternalServerErrorView.disableFooter = true;
/* harmony default export */ var internal_server_error_InternalServerErrorView = (InternalServerErrorView_InternalServerErrorView);
// EXTERNAL MODULE: ./src/client/views/errors/not-found/NotFoundView.jsx
var NotFoundView = __webpack_require__("LP0I");

// CONCATENATED MODULE: ./pages/_error.js


















var _error_jsx = react_default.a.createElement;

function _error_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _error_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? _error_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : _error_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


 // import type { GetServerSidePropsContext } from 'next'; // not importable from flowtyped atm










var QUERY_404 = "query {\n  config {\n    errors {\n      notFound {\n        description\n        image\n        items {\n          backgroundURL\n          label\n          link\n        }\n        title\n      }\n    }\n    common { goToHome }\n  }\n}";
var notFoundInitialProps = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(req) {
    var appContext;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!req) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return Object(createAppContextFromReq["a" /* createAppContextFromReq */])(req);

          case 3:
            _context.t0 = _context.sent;
            _context.next = 7;
            break;

          case 6:
            _context.t0 = Object(createOrUpdateAppContext["a" /* getAppContext */])();

          case 7:
            appContext = _context.t0;
            return _context.abrupt("return", graphqlClient["a" /* default */].runQuery(QUERY_404, appContext, {
              requestName: requestDictionary["sc" /* PAGE_404 */]
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function notFoundInitialProps(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getHost = function getHost(req) {
  var _ref2, _req$get;

  if (true) {
    return document.location.host;
  }

  if (req.headers['x-forwarded-host']) {
    return req.headers['x-forwarded-host'];
  }

  return (_ref2 = (_req$get = req.get('host')) !== null && _req$get !== void 0 ? _req$get : req.headers.host) !== null && _ref2 !== void 0 ? _ref2 : 'localhost:3000';
};

var getProtocol = function getProtocol(req) {
  var _req$headers$xForwar;

  if (true) {
    return document.location.protocol;
  }

  var protocol = (_req$headers$xForwar = req.headers['x-forwarded-proto']) !== null && _req$headers$xForwar !== void 0 ? _req$headers$xForwar : req.protocol;

  if (!protocol) {
    return 'https:';
  }

  if (!protocol.endsWith(':')) {
    return "".concat(protocol, ":");
  }

  return protocol;
};

var getHostname = function getHostname(req) {
  if (true) {
    return document.location.hostname;
  }

  return new URL("".concat(getProtocol(req), "//").concat(getHost(req))).hostname;
};

var _error_ErrorPage = function ErrorPage(_ref3) {
  var statusCode = _ref3.statusCode,
      props = Object(objectWithoutProperties["a" /* default */])(_ref3, ["statusCode"]);

  if (statusCode === statusCode_constants["d" /* STATUS_CODE_404 */]) {
    return _error_jsx(NotFoundView["a" /* default */], props);
  }

  return _error_jsx(internal_server_error_InternalServerErrorView, props);
};

_error_ErrorPage.pageId = 'ErrorPage';

_error_ErrorPage.getInitialProps = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4) {
    var req, res, query, err, props, hostname, locale, _domainsService$getCu, error;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            req = _ref4.req, res = _ref4.res, query = _ref4.query, err = _ref4.err;

            if (!((res === null || res === void 0 ? void 0 : res.statusCode) === statusCode_constants["d" /* STATUS_CODE_404 */] || (err === null || err === void 0 ? void 0 : err.statusCode) === statusCode_constants["d" /* STATUS_CODE_404 */] || query.statusCode === statusCode_constants["d" /* STATUS_CODE_404 */].toString())) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return notFoundInitialProps(req);

          case 4:
            props = _context2.sent;
            res === null || res === void 0 ? void 0 : res.status(statusCode_constants["d" /* STATUS_CODE_404 */]);
            return _context2.abrupt("return", _error_objectSpread(_error_objectSpread({}, props), {}, {
              statusCode: statusCode_constants["d" /* STATUS_CODE_404 */]
            }));

          case 7:
            hostname = getHostname(req);
            locale = Object(contextUtils["a" /* getCurrentLocale */])(query.locale, hostname);
            _domainsService$getCu = dist_default.a.getCurrentDomain(locale), error = _domainsService$getCu.error_500;
            res === null || res === void 0 ? void 0 : res.status(statusCode_constants["f" /* STATUS_CODE_500 */]);
            return _context2.abrupt("return", {
              error: error,
              statusCode: statusCode_constants["f" /* STATUS_CODE_500 */]
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref5.apply(this, arguments);
  };
}();

/* harmony default export */ var _error = __webpack_exports__["default"] = (_error_ErrorPage);

/***/ }),

/***/ "dIgr":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": [
		"tGlX",
		50
	],
	"./de-at": [
		"s+uk",
		48
	],
	"./de-at.js": [
		"s+uk",
		48
	],
	"./de-ch": [
		"u3GI",
		49
	],
	"./de-ch.js": [
		"u3GI",
		49
	],
	"./de.js": [
		"tGlX",
		50
	],
	"./en-SG": [
		"zavE",
		51
	],
	"./en-SG.js": [
		"zavE",
		51
	],
	"./en-au": [
		"Dmvi",
		52
	],
	"./en-au.js": [
		"Dmvi",
		52
	],
	"./en-ca": [
		"OIYi",
		53
	],
	"./en-ca.js": [
		"OIYi",
		53
	],
	"./en-gb": [
		"Oaa7",
		54
	],
	"./en-gb.js": [
		"Oaa7",
		54
	],
	"./en-ie": [
		"4dOw",
		55
	],
	"./en-ie.js": [
		"4dOw",
		55
	],
	"./en-il": [
		"czMo",
		56
	],
	"./en-il.js": [
		"czMo",
		56
	],
	"./en-nz": [
		"b1Dy",
		57
	],
	"./en-nz.js": [
		"b1Dy",
		57
	],
	"./es": [
		"iYuL",
		60
	],
	"./es-do": [
		"CjzT",
		58
	],
	"./es-do.js": [
		"CjzT",
		58
	],
	"./es-us": [
		"Vclq",
		59
	],
	"./es-us.js": [
		"Vclq",
		59
	],
	"./es.js": [
		"iYuL",
		60
	],
	"./fr": [
		"nyYc",
		63
	],
	"./fr-ca": [
		"2fjn",
		61
	],
	"./fr-ca.js": [
		"2fjn",
		61
	],
	"./fr-ch": [
		"Dkky",
		62
	],
	"./fr-ch.js": [
		"Dkky",
		62
	],
	"./fr.js": [
		"nyYc",
		63
	],
	"./he": [
		"x6pH",
		64
	],
	"./he.js": [
		"x6pH",
		64
	],
	"./id": [
		"UDhR",
		65
	],
	"./id.js": [
		"UDhR",
		65
	],
	"./it": [
		"bpih",
		67
	],
	"./it-ch": [
		"bxKX",
		66
	],
	"./it-ch.js": [
		"bxKX",
		66
	],
	"./it.js": [
		"bpih",
		67
	],
	"./ja": [
		"B55N",
		68
	],
	"./ja.js": [
		"B55N",
		68
	],
	"./ko": [
		"Ivi+",
		69
	],
	"./ko.js": [
		"Ivi+",
		69
	],
	"./nl": [
		"+s0g",
		71
	],
	"./nl-be": [
		"2ykv",
		70
	],
	"./nl-be.js": [
		"2ykv",
		70
	],
	"./nl.js": [
		"+s0g",
		71
	],
	"./pt": [
		"8mBD",
		73
	],
	"./pt-br": [
		"0tRk",
		72
	],
	"./pt-br.js": [
		"0tRk",
		72
	],
	"./pt.js": [
		"8mBD",
		73
	],
	"./ru": [
		"lXzo",
		74
	],
	"./ru.js": [
		"lXzo",
		74
	],
	"./th": [
		"EOgW",
		75
	],
	"./th.js": [
		"EOgW",
		75
	],
	"./tr": [
		"DoHr",
		76
	],
	"./tr.js": [
		"DoHr",
		76
	],
	"./uk": [
		"raLr",
		77
	],
	"./uk.js": [
		"raLr",
		77
	],
	"./zh-cn": [
		"XDpg",
		78
	],
	"./zh-cn.js": [
		"XDpg",
		78
	],
	"./zh-tw": [
		"kOpN",
		79
	],
	"./zh-tw.js": [
		"kOpN",
		79
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dIgr";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "xb8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createAppContextFromReq; });

// UNUSED EXPORTS: createAppContextFromProps

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("6LKR");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ../utils/dist/index.js
var utils_dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/set.js
var set = __webpack_require__("DL3M");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/utils/feature-flipping/featureFlipping.query.js










var featureFlipping_query_convertKeysToObject = function convertKeysToObject(keys) {
  return keys.reduce(function (featureFlips, _ref) {
    var key = _ref.key,
        value = _ref.value;
    return set_default()(featureFlips, key, value);
  }, {});
};

var fetchFeatureFlippingKeys = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(appContext) {
    var _featureFlippingKeys$;

    var featureFlippingKeysQuery, _yield$graphQLClient$, featureFlippingKeys;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            featureFlippingKeysQuery = "query {\n    featureFlippingKeys {\n      keys {\n        key\n        value\n      }\n    }\n  }";
            _context.next = 3;
            return graphqlClient["a" /* default */].runQuery(featureFlippingKeysQuery, appContext, {
              requestName: requestDictionary["f" /* CORE_GET_FEATURE_FLIPPING_KEYS */]
            });

          case 3:
            _yield$graphQLClient$ = _context.sent;
            featureFlippingKeys = _yield$graphQLClient$.featureFlippingKeys;

            if (featureFlippingKeys === null || featureFlippingKeys === void 0 ? void 0 : (_featureFlippingKeys$ = featureFlippingKeys.keys) === null || _featureFlippingKeys$ === void 0 ? void 0 : _featureFlippingKeys$.length) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            return _context.abrupt("return", featureFlipping_query_convertKeysToObject(featureFlippingKeys.keys));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeatureFlippingKeys(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/client/context/fetchFeatureFlippingKeysFromCms.js





function fetchFeatureFlippingKeysFromCms(_x) {
  return _fetchFeatureFlippingKeysFromCms.apply(this, arguments);
}

function _fetchFeatureFlippingKeysFromCms() {
  _fetchFeatureFlippingKeysFromCms = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(appContext) {
    var keys;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (config_default.a.get('cms.enableFeatureFlippingFromCms')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return fetchFeatureFlippingKeys(appContext);

          case 5:
            keys = _context.sent;
            return _context.abrupt("return", keys);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            logger_default.a.error(_context.t0);
            return _context.abrupt("return", null);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _fetchFeatureFlippingKeysFromCms.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/client/context/initAppContext.js
var initAppContext = __webpack_require__("yEwm");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.helper.js
var Responsive_helper = __webpack_require__("GRjW");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.constants.js
var Responsive_constants = __webpack_require__("I6kL");

// CONCATENATED MODULE: ./src/server/context/createAppContextFromReq.js
















 // import type { GetStaticPropsContext } from 'next'; // not importable from flowtyped atm



function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var AKAMAI_DEVICE_DETECTION = 'x-akamai-device-characteristics';

var createAppContextFromReq_mapAkamaiDeviceHeader = function mapAkamaiDeviceHeader(header) {
  var _header$trim$split = header.trim().split('='),
      _header$trim$split2 = Object(slicedToArray["a" /* default */])(_header$trim$split, 2),
      key = _header$trim$split2[0],
      value = _header$trim$split2[1];

  try {
    return [key, JSON.parse(value)];
  } catch (_unused) {
    return [key, value.trim()];
  }
};

var parseAkamaiDeviceHeader = function parseAkamaiDeviceHeader(akamaiHeader) {
  if (!akamaiHeader) {
    return null;
  }

  return Object.fromEntries(akamaiHeader.split(';').map(createAppContextFromReq_mapAkamaiDeviceHeader));
};

var createAppContextFromReq_getDevice = function getDevice(req) {
  var deviceDetection = parseAkamaiDeviceHeader(req.headers[AKAMAI_DEVICE_DETECTION]);

  if (!deviceDetection) {
    return Object(Responsive_helper["c" /* getDeviceByUA */])(req.headers['user-agent']);
  }

  if (deviceDetection.is_mobile === true) {
    return Responsive_constants["b" /* DEVICES */].MOBILE;
  }

  return Responsive_constants["b" /* DEVICES */].DESKTOP;
};

var createAppContextFromReq_createAppContextFromProps = function createAppContextFromProps(appContext) {
  var uri = new URI_default.a(appContext.originalUrl);
  var hostname = uri.hostname();
  var domainServiceForHostname = dist_default.a.forHostname(hostname);
  return _objectSpread(_objectSpread({}, appContext), {}, {
    availableLocales: domainServiceForHostname.getAllLocales(),
    defaultLocale: domainServiceForHostname.getDefaultLocale()
  }, Object(initAppContext["a" /* initAppContext */])(appContext.originalUrl, appContext));
};
var createAppContextFromReq = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(req) {
    var requestId, uri, queryParameters, requestedLocale, hostname, domainServiceForHostname, availableLocales, defaultLocale, locale, host, userAgent, baseAppContext, appContext, featureFlippingKeysFromCms;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // $FlowFixMe: id is injected from express-request-id
            requestId = req.headers[utils_dist["httpHeaders"].X_REQUEST_ID] || req.id;
            uri = Object(contextUtils["b" /* getCurrentUri */])(req);
            queryParameters = utils_dist["url"].decodeQueryParameters(uri.query(true));
            requestedLocale = queryParameters.locale;
            hostname = uri.hostname();
            domainServiceForHostname = dist_default.a.forHostname(hostname);
            availableLocales = domainServiceForHostname.getAllLocales();
            defaultLocale = domainServiceForHostname.getDefaultLocale();
            locale = Object(contextUtils["a" /* getCurrentLocale */])(requestedLocale, hostname); // $FlowFixMe we have a host

            host = req.get('host');
            userAgent = req.headers['user-agent'];
            baseAppContext = {
              availableLocales: availableLocales,
              cookies: req.cookies,
              defaultLocale: defaultLocale,
              locale: locale,
              originalUrl: req.protocol + '://' + host + req.originalUrl,
              requestId: requestId,
              userAgent: userAgent,
              device: createAppContextFromReq_getDevice(req)
            };
            moment_default.a.locale(get_default()(availableLocales, "".concat(locale, ".moment"), 'fr'));
            appContext = _objectSpread(_objectSpread({}, baseAppContext), Object(initAppContext["a" /* initAppContext */])(uri, baseAppContext));
            _context.next = 16;
            return fetchFeatureFlippingKeysFromCms(appContext);

          case 16:
            featureFlippingKeysFromCms = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, appContext), typeof featureFlippingKeysFromCms === 'object' && {
              featureFlippingKeysFromCms: featureFlippingKeysFromCms
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createAppContextFromReq(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "yEwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppContext; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zygG");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _routes_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("dNxv");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("igjW");
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KL6I");













function initAppContext(uri) {
  var _availableLocales$loc, _availableLocales$loc2, _availableLocales$loc3, _encodedUserInfo, _encodedUserInfo2, _encodedUserInfo3, _encodedUserInfo4;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cookies = _ref.cookies,
      cookies = _ref$cookies === void 0 ? {} : _ref$cookies,
      _ref$featureFlippingK = _ref.featureFlippingKeysFromCms,
      featureFlippingKeysFromCms = _ref$featureFlippingK === void 0 ? null : _ref$featureFlippingK,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'fr-FR' : _ref$locale,
      originalUrl = _ref.originalUrl,
      requestId = _ref.requestId,
      userAgent = _ref.userAgent,
      device = _ref.device;

  var _ref2 = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6___default.a.isValidLocale(locale) ? locale.split('-') : [],
      _ref3 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_ref2, 2),
      language = _ref3[0],
      country = _ref3[1];

  var uriObject = new urijs__WEBPACK_IMPORTED_MODULE_5___default.a(uri);
  var queryParameters = uriObject.query(true);
  var isComingFromMobileApp = !!(queryParameters === null || queryParameters === void 0 ? void 0 : queryParameters.fromMobileApp) || !!cookies.fromMobileApp;
  var encodedUserInfo = cookies[_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__[/* USER_INFO */ "e"]] ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["oidc"].fromUriEncodedState(cookies[_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__[/* USER_INFO */ "e"]]) : undefined; // handle the mobile App

  if (isComingFromMobileApp && !encodedUserInfo && (queryParameters === null || queryParameters === void 0 ? void 0 : queryParameters.cm_userinfo)) {
    encodedUserInfo = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["oidc"].fromUriEncodedState(queryParameters === null || queryParameters === void 0 ? void 0 : queryParameters.cm_userinfo) || undefined;
  }

  var sellerInfoCookies = cookies[_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__[/* SELLER_INFO */ "c"]] ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["oidc"].fromUriEncodedState(cookies[_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__[/* SELLER_INFO */ "c"]]) : undefined;
  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6___default.a.forHostname(uriObject.hostname());
  var availableLocales = domainServiceForHostname.getAllLocales();
  var defaultLocale = domainServiceForHostname.getDefaultLocale();
  var cm_ta = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["appQueryParameters"].cmta.cm_ta,
      cxo_sales_network_id = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["appQueryParameters"].cxo.cxo_sales_network_id,
      indirect = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["appQueryParameters"].indirect;
  var isCmta = queryParameters[cm_ta] !== undefined;
  var isIndirect = queryParameters[indirect] !== undefined;
  var isDirectCxo = !!queryParameters[cxo_sales_network_id] && !isIndirect && !isCmta || !!queryParameters.cxo_neolid;
  var isIndirectCxo = !!queryParameters[cxo_sales_network_id] && isIndirect && !isCmta;
  var isCxo = isDirectCxo || isIndirectCxo;
  var localeCurrencies = (availableLocales === null || availableLocales === void 0 ? void 0 : (_availableLocales$loc = availableLocales[locale]) === null || _availableLocales$loc === void 0 ? void 0 : _availableLocales$loc.currencies) || {};
  var currencyCode = Object.keys(localeCurrencies)[0]; // EUR

  return {
    freeDepositDeadline: 999,
    authenticationToken: cookies[_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__[/* ACCESS_TOKEN */ "a"]] || cookies.CM_SELLER_TOKEN || (isComingFromMobileApp ? queryParameters.CM_TOKEN : ''),
    availableLocales: availableLocales,
    bypassCache: queryParameters[_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["appQueryParameters"].bypassCache] === 'true',
    canUseOnlinePayment: _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6___default.a.getEnabledPaymentProviders(locale).length > 0,
    cmsContent: queryParameters.commonContent || _config__WEBPACK_IMPORTED_MODULE_8___default.a.get('cms.commonContent'),
    cmsRelease: queryParameters.commonRelease || _config__WEBPACK_IMPORTED_MODULE_8___default.a.get('cms.commonRelease'),
    cmta: isCmta ? {
      agency: (sellerInfoCookies === null || sellerInfoCookies === void 0 ? void 0 : sellerInfoCookies.agency) || '',
      agent: (sellerInfoCookies === null || sellerInfoCookies === void 0 ? void 0 : sellerInfoCookies.agent) || '',
      isDelCredere: (sellerInfoCookies === null || sellerInfoCookies === void 0 ? void 0 : sellerInfoCookies.isDelCredere) || false,
      email: (sellerInfoCookies === null || sellerInfoCookies === void 0 ? void 0 : sellerInfoCookies.email) || '',
      searchType: uriObject.path() === _routes_constants__WEBPACK_IMPORTED_MODULE_9__[/* QUICK_SEARCH_URL */ "y"] ? 'quick' : 'advanced',
      salesmanID: (sellerInfoCookies === null || sellerInfoCookies === void 0 ? void 0 : sellerInfoCookies.salesmanID) || ''
    } : {},
    cookies: cookies,
    country: country || '',
    countryCode: availableLocales === null || availableLocales === void 0 ? void 0 : (_availableLocales$loc2 = availableLocales[locale]) === null || _availableLocales$loc2 === void 0 ? void 0 : _availableLocales$loc2.PAYS,
    countryName: availableLocales === null || availableLocales === void 0 ? void 0 : (_availableLocales$loc3 = availableLocales[locale]) === null || _availableLocales$loc3 === void 0 ? void 0 : _availableLocales$loc3.name,
    // $FlowFixMe
    currency: currencyCode,
    customerNeolaneId: queryParameters.cxo_neolid,
    callReference: queryParameters.call_reference,
    contactID: queryParameters.contactID,
    customerType: ((_encodedUserInfo = encodedUserInfo) === null || _encodedUserInfo === void 0 ? void 0 : _encodedUserInfo.customerType) || '',
    customerStatus: ((_encodedUserInfo2 = encodedUserInfo) === null || _encodedUserInfo2 === void 0 ? void 0 : _encodedUserInfo2.customerStatus) || '',
    cxoQueryParams: isCxo ? {
      salesman_code: queryParameters.salesman_code,
      cxo_azur_code: queryParameters.cxo_azur_code || cookies.cxo_azur_code,
      cxo_sales_channel: queryParameters.cxo_sales_channel || cookies.cxo_sales_channel,
      cxo_country_code: queryParameters.cxo_country_code || cookies.cxo_country_code,
      cxo_user_id: typeof queryParameters.cxo_id === 'string' ? Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__[/* decryptHeptaSeller */ "a"])(queryParameters.cxo_id) : queryParameters.cxo_user_id || cookies.cxo_user_id || ''
    } : {},
    defaultLocale: defaultLocale,
    displayUnicodeFields: _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_6___default.a.shouldDisplayUnicodeFields(locale) || false,
    featureFlippingKeysFromCms: featureFlippingKeysFromCms,
    // TODO replace this by - and improve for SSR - GoogleAnalytics tracking helper
    googleTrackingId: queryParameters.visitorGUID || cookies._ga || null,
    headers: {},
    isProduction: Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_10__[/* isProduction */ "c"])(),
    isCmta: isCmta,
    isCxo: isCxo,
    isDirectCxo: isDirectCxo,
    isIndirectCxo: isIndirectCxo,
    isSeller: isCmta || isDirectCxo || isIndirectCxo,
    isSellerLogged: cookies[_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__[/* SELLER_LOGGED */ "d"]] === 'true',
    isUserLogged: ((_encodedUserInfo3 = encodedUserInfo) === null || _encodedUserInfo3 === void 0 ? void 0 : _encodedUserInfo3.isLoggedIn) || false,
    isUserQuickLogged: ((_encodedUserInfo4 = encodedUserInfo) === null || _encodedUserInfo4 === void 0 ? void 0 : _encodedUserInfo4.isQuickLoggedIn) || false,
    isComingFromMobileApp: isComingFromMobileApp,
    language: language || '',
    lines: [],
    locale: locale,
    neolaneId: cookies.cm_client_uid || encodedUserInfo && encodedUserInfo.neolaneId || queryParameters.cxo_neolId || null,
    originalUrl: originalUrl,
    pagesContent: queryParameters.pagesContent || _config__WEBPACK_IMPORTED_MODULE_8___default.a.get('cms.pagesContent'),
    pagesRelease: queryParameters.pagesRelease || _config__WEBPACK_IMPORTED_MODULE_8___default.a.get('cms.pagesRelease'),
    requestId: requestId,
    userAgent: userAgent,
    device: device,
    setCustomerStatus: function setCustomerStatus() {}
  };
}

/***/ })

}]);